import { render, staticRenderFns } from "./CheckOff.vue?vue&type=template&id=065067a6"
import script from "./CheckOff.vue?vue&type=script&lang=js"
export * from "./CheckOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports